const s = {
  name: "CheckoutDropIn",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M3,2h4V0H3V2z"/>
		<path class="st0" d="M3,16h4v-2H3V16z"/>
		<path class="st0" d="M13,2H9V0h4V2z"/>
		<path class="st0" d="M9,16h4v-2H9V16z"/>
		<path class="st0" d="M19,2h-4V0h4V2z"/>
		<path class="st0" d="M15,16h2v-2h-2V16z"/>
		<path class="st0" d="M25,2h-4V0h4V2z"/>
		<path class="st0" d="M23,16h2v-2h-2V16z"/>
		<path class="st0" d="M31,2h-4V0h4V2z"/>
		<path class="st0" d="M27,16h4v-2h-4V16z"/>
		<path class="st0" d="M37,2h-4V0h4V2z"/>
		<path class="st0" d="M33,16h4v-2h-4V16z"/>
		<path class="st0" d="M0,7V3h2v4H0z"/>
		<path class="st0" d="M0,9v4h2V9H0z"/>
		<path class="st0" d="M38,7V3h2v4H38z"/>
		<path class="st0" d="M38,9v4h2V9H38z"/>
		<path class="st0" d="M21,8h-2v16H3c-1.7,0-3,1.3-3,3v10c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V27c0-1.7-1.3-3-3-3H21V8z M19,26v6.6
			l-3.3-3.3l-1.4,1.4l5.7,5.7l5.7-5.7l-1.4-1.4L21,32.6V26h16c0.6,0,1,0.4,1,1v10c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V27
			c0-0.6,0.4-1,1-1H19z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CheckoutDropIn
};
